import { reactApp } from './common.constants';

export const BASE_URL = `${reactApp().apiUrl}/api`;
export const BASE_NET_URL_PACE = `${reactApp().apiNetUrl}/pace/v1`;
export const BASE_NET_URL_MOD = `${reactApp().apiNetUrl}/mod/v1`;
export const GM_API_KEY = 'AIzaSyA-D7o_JmuBNpR503C7J6P5BRvVuNxhzLo';
